/* ==========================================================================
   CADOO CHECKOUT GUARD — narrow fallback only.

   The Cadoo journey is:

     cart drawer Checkout  ─┐
     gift bag Checkout     ─┴─▶ /cart?view=gifting-details
                                  ├─ Back     ▶ /cart
                                  └─ Continue ▶ /cart?view=delivery-setup
                                                  ├─ Back     ▶ /cart?view=gifting-details
                                                  └─ Continue ▶ /checkout

   Every one of those destinations is owned by Liquid, in the markup of the
   control itself. None of them relies on this file, and this file does not
   touch any of them.

   What is left here is deliberately small. It exists for controls this theme
   does not author - a Shopify-injected accelerated checkout button, an app
   block, a hand-written /checkout link - which would otherwise hand the
   customer to the Shopify checkout with no gifting or delivery details
   collected. It is NOT a blanket interceptor:

     · it never runs on the two custom steps, which own their own navigation;
     · it only looks at controls OUTSIDE the Cadoo step sections;
     · it only matches a native Shopify checkout submit (a control actually
       named "checkout") or a link whose path is exactly /checkout - not every
       link that happens to contain the word;
     · it sends those to step 1, Gifting Details, never to step 2, so a stray
       control can never skip a step either.

   It performs no history manipulation of any kind: no history.back(), no
   replaceState, no pushState, and it never listens for popstate. The
   browser's own Back and Forward buttons behave normally.
   ========================================================================== */
(function () {
  'use strict';

  var docEl = document.documentElement;

  /* The custom steps mark themselves before any deferred script runs. Each one
     performs its own, legitimate hand-over once Shopify has confirmed the cart
     write, so the guard stands down entirely on both. */
  if (docEl.hasAttribute('data-cd-delivery-setup')) return;
  if (docEl.hasAttribute('data-cd-gifting-details')) return;

  var routes = (window.CadooConfig && window.CadooConfig.routes) || {};
  var CART_URL = routes.cart || '/cart';
  var STEP_ONE_URL = CART_URL + (CART_URL.indexOf('?') === -1 ? '?' : '&') + 'view=gifting-details';
  var ROOT_URL = routes.root || '/';
  var CHECKOUT_PATH = (ROOT_URL === '/' ? '' : ROOT_URL.replace(/\/$/, '')) + '/checkout';

  function go() {
    window.location.assign(STEP_ONE_URL);
  }

  /* Anything inside a Cadoo-owned control belongs to the custom flow and is
     left strictly alone. */
  function isCadooOwned(el) {
    return !!(el.closest('[data-cd-gd]') ||
              el.closest('[data-cd-ds]') ||
              el.closest('[data-cd-cart-checkout]'));
  }

  /* ---------- 1. A native Shopify cart-checkout submit ----------
     Shopify's convention is a cart form whose submit control is named
     "checkout". The Cadoo controls are deliberately not named that and do not
     post to /checkout, so this only ever fires for markup this theme did not
     write. */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (isCadooOwned(form)) return;

      var submitter = e.submitter || null;
      var control = submitter && submitter.name === 'checkout'
        ? submitter
        : form.querySelector('[name="checkout"]');
      if (!control) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      go();
    },
    true
  );

  /* ---------- 2. A link straight to the Shopify checkout ----------
     Matched on the resolved pathname, so a product called "checkout" or a
     collection URL containing the word is never caught. */
  document.addEventListener(
    'click',
    function (e) {
      var el = e.target && e.target.closest ? e.target.closest('a[href], [name="checkout"]') : null;
      if (!el || isCadooOwned(el)) return;

      if (el.tagName === 'A') {
        var path;
        try { path = new URL(el.href, window.location.origin).pathname.replace(/\/$/, ''); }
        catch (err) { return; }
        if (path !== CHECKOUT_PATH.replace(/\/$/, '')) return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();
      go();
    },
    true
  );

  /* ---------- 3. Accelerated checkout ----------
     Shop Pay / PayPal / Google Pay buttons render inside closed shadow roots
     and post straight to the payment provider, skipping the cart entirely - so
     they are removed rather than intercepted. The matching CSS in
     layout/theme.liquid keeps them from ever painting; this sweep removes any
     injected later. */
  var ACCEL = [
    'shopify-accelerated-checkout',
    'shopify-accelerated-checkout-cart',
    '.shopify-payment-button',
    '.additional-checkout-buttons',
    '#dynamic-checkout-cart',
    '[data-shopify="dynamic-checkout-cart"]',
    '[data-shopify="dynamic-checkout-buttons"]'
  ].join(',');

  function sweep() {
    var nodes = document.querySelectorAll(ACCEL);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].parentNode) nodes[i].parentNode.removeChild(nodes[i]);
    }
  }

  sweep();

  if (window.MutationObserver) {
    new MutationObserver(sweep).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
